export enum DefaultPropertyTypeNames {
  Hotel = 'Hotel',
  Apartment = 'Apartment',
  Aparthotel = 'Aparthotel',
  NotSet = 'NotSet',
}

export enum AdditionalPropertyTypeNames {
  Hostel = 'Hostel',
  Motel = 'Motel',
  BedAndBreakfast = 'BedAndBreakfast',
  Villa = 'Villa',
  Guesthouse = 'Guesthouse',
  HolidayHome = 'HolidayHome',
  Lodge = 'Lodge',
  Homestay = 'Homestay',
  Cottage = 'Cottage',
  Inn = 'Inn',
  Cabin = 'Cabin',
  Chalet = 'Chalet',
  Pension = 'Pension',
  Townhouse = 'Townhouse',
  CountryHouse = 'CountryHouse',
}

export const PropertyTypeName = {
  ...DefaultPropertyTypeNames,
  ...AdditionalPropertyTypeNames,
} as const;

export type PropertyTypeName = DefaultPropertyTypeNames | AdditionalPropertyTypeNames;

export enum PropertyTypeLabels {
  Hotel = 'searchableProperties.hotel',
  Apartment = 'searchableProperties.apartment',
  Aparthotel = 'searchableProperties.aparthotel',
  Hostel = 'searchableProperties.hostel',
  Motel = 'searchableProperties.motel',
  BedAndBreakfast = 'searchableProperties.bedAndBreakfast',
  Villa = 'searchableProperties.villa',
  Guesthouse = 'searchableProperties.guesthouse',
  HolidayHome = 'searchableProperties.holidayHome',
  Lodge = 'searchableProperties.lodge',
  Homestay = 'searchableProperties.homestay',
  Cottage = 'searchableProperties.cottage',
  Inn = 'searchableProperties.inn',
  Cabin = 'searchableProperties.cabin',
  Chalet = 'searchableProperties.chalet',
  Pension = 'searchableProperties.pension',
  Townhouse = 'searchableProperties.townhouse',
  CountryHouse = 'searchableProperties.countryHouse',
}
